export enum CertificateType {
    ATTENDANCE = 'attendance',
    GRADEBOOK = 'gradebook',
    MODULE_PARTICIPANT_CERTIFICATION = 'module_participant_certification',
    USER_CERTIFICATION = 'user_certificate',
    EXTERNAL_COURSE_CONFIRMATION = 'external_course_confirmation',
}
